import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import emailjs from "@emailjs/browser";
import swal from "sweetalert";


const services = [
  {
    number: "01",
    title: "DIRECCIÓN & ESTRATEGIA",
    text: "Objetivos, posicionamiento, plan de marketing, campañas y prioridades. Ordenamos qué hacer, por qué y en qué secuencia.",
    tags: ["PLAN DE MARKETING", "POSICIONAMIENTO", "CAMPAÑAS", "COORDINACIÓN"],
  },
  {
    number: "02",
    title: "CONTENIDO & REDES",
    text: "Conceptos, calendarios, diseño, copy, video y gestión de redes. Contenido con función dentro del negocio, no por llenar casilleros.",
    tags: ["SOCIAL MEDIA", "CREATIVIDAD", "DISEÑO", "PRODUCCIÓN"],
  },
  {
    number: "03",
    title: "PAUTA & PERFORMANCE",
    text: "Meta Ads, Google Ads y campañas segmentadas para generar demanda, aprender rápido y mover presupuesto hacia lo que funciona.",
    tags: ["META ADS", "GOOGLE ADS", "SEM", "REMARKETING"],
  },
  {
    number: "04",
    title: "WEB & CONVERSIÓN",
    text: "Sitios, landings y recorridos pensados para que la visita haga algo: consultar, comprar, reservar, dejar un dato o avanzar.",
    tags: ["WEB", "LANDING PAGES", "SEO ON-PAGE", "CRO"],
  },
  {
    number: "05",
    title: "CRM, EMAIL & AUTOMATIZACIÓN",
    text: "Seguimiento, email marketing y automatizaciones para que los contactos no se pierdan y la comunicación no dependa de acordarse a mano.",
    tags: ["EMAIL MARKETING", "CRM", "AUTOMATIZACIÓN", "FOLLOW-UP"],
  },
  {
    number: "06",
    title: "DATOS, REPORTING & IA",
    text: "Medición, análisis, dashboards e IA aplicada donde suma: investigación, producción, optimización y velocidad de respuesta.",
    tags: ["ANALYTICS", "REPORTING", "INSIGHTS", "IA"],
  },
];

const process = [
  { number: "01", title: "ENTENDEMOS", text: "Negocio, contexto, producto, competencia y qué querés conseguir." },
  { number: "02", title: "PRIORIZAMOS", text: "Definimos el objetivo y elegimos las acciones que realmente tienen sentido." },
  { number: "03", title: "HACEMOS", text: "Estrategia, creatividad, medios y tecnología trabajando como una sola cosa." },
  { number: "04", title: "MEDIMOS", text: "Miramos qué pasó, qué aprendimos y dónde hay una oportunidad de mejora." },
  { number: "05", title: "AJUSTAMOS", text: "Lo que funciona escala. Lo que no, cambia. El plan nunca queda congelado." },
];

const clients = [
  { file: "philips", name: "Philips" },
  { file: "gatorade", name: "Gatorade" },
  { file: "heinz", name: "Heinz" },
  { file: "sanofi", name: "Sanofi" },
  { file: "boehringer", name: "Boehringer Ingelheim" },
  { file: "atlantida", name: "Editorial Atlántida" },
  { file: "bafweek", name: "BAFWeek" },
  { file: "chiclets", name: "Chiclets" },
  { file: "fundacion-noble", name: "Fundación Noble" },
  { file: "poett-fraganza", name: "Poett" },
  { file: "yaskia", name: "Yaskia" },
  { file: "eni", name: "ENI" },
];

const getAttribution = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get("utm_source") || "",
    utm_medium: params.get("utm_medium") || "",
    utm_campaign: params.get("utm_campaign") || "",
    utm_content: params.get("utm_content") || "",
    referrer: document.referrer || "",
    landing_url: window.location.href,
  };
};

const Home = () => {
  const { hash } = useLocation();
  const form = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [formStarted, setFormStarted] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const empresaValue = watch("empresa", "");

  const track = (eventName, params = {}) => {
    try {
      if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("event", eventName, params);
      }
    } catch (error) {
      console.warn("Analytics event skipped", error);
    }
  };

  useEffect(() => {
    document.body.classList.toggle("menu-open", menuOpen);
    return () => document.body.classList.remove("menu-open");
  }, [menuOpen]);

  useEffect(() => {
    track("page_view_momo", { page_path: window.location.pathname });

    if (hash) {
      window.setTimeout(() => {
        const target = document.querySelector(hash);
        if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  const closeMenu = () => setMenuOpen(false);

  const handleCta = (placement) => {
    track("cta_click", { placement, cta: "hablemos" });
    closeMenu();
  };

  const handleFormFocus = () => {
    if (!formStarted) {
      setFormStarted(true);
      track("lead_form_start", { page: "momo-home" });
    }
  };

  const createContact = async (data) => {
    if (isSending) return;
    setIsSending(true);

    try {
      await emailjs.sendForm(
        "gmail",
        "mail-contacto",
        form.current,
        "ywpL1dRWg4rq2UiEr"
      );

      track("generate_lead", {
        origin: "web-momo-2026",
        lead_type: data.mensaje,
      });

      await swal(
        "¡GRACIAS!",
        "Recibimos tus datos. En breve te contactamos para conocer un poco más sobre tu negocio.",
        "success"
      );

      reset();
      setFormStarted(false);
    } catch (error) {
      console.error(error);
      track("lead_form_error", { page: "momo-home" });
      swal("¡UPS!", "No pudimos enviar tus datos. Probá nuevamente en unos minutos.", "error");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="site">
      <header className="topbar">
        <a className="brand" href="#inicio" onClick={closeMenu} aria-label="MOMO Agencia - Inicio">
          <img src="/img/logoN.png" alt="MOMO! Agencia" />
        </a>

        <nav className="desktop-nav" aria-label="Navegación principal">
          <a href="#servicios">QUÉ HACEMOS</a>
          <a href="#marketing-externo">MARKETING EXTERNO</a>
          <a href="#metodo">CÓMO TRABAJAMOS</a>
          <a href="#clientes">CLIENTES</a>
        </nav>

        <div className="topbar-actions">
          <a className="topbar-cta" href="#hablemos" onClick={() => handleCta("header")}>
            HABLEMOS <span aria-hidden="true">↘</span>
          </a>
          <button
            className="menu-button"
            type="button"
            aria-expanded={menuOpen}
            aria-label={menuOpen ? "Cerrar menú" : "Abrir menú"}
            onClick={() => setMenuOpen((value) => !value)}
          >
            <span></span><span></span>
          </button>
        </div>

        <div className={`mobile-menu ${menuOpen ? "is-open" : ""}`}>
          <a href="#servicios" onClick={closeMenu}>QUÉ HACEMOS</a>
          <a href="#marketing-externo" onClick={closeMenu}>MARKETING EXTERNO</a>
          <a href="#metodo" onClick={closeMenu}>CÓMO TRABAJAMOS</a>
          <a href="#clientes" onClick={closeMenu}>CLIENTES</a>
          <a href="#hablemos" onClick={() => handleCta("mobile_menu")}>HABLEMOS ↘</a>
        </div>
      </header>

      <main>
        <section className="hero" id="inicio">
          <div className="hero-copy">
            <p className="eyebrow">AGENCIA DE MARKETING · ESTRATEGIA + EJECUCIÓN</p>
            <h1>
              MARKETING QUE
              <br />
              MUEVE NEGOCIOS.
              <br />
              <span>NO SOLO MÉTRICAS.</span>
            </h1>
            <p className="hero-lead">
              Hace más de 15 años ayudamos a marcas y PyMEs a convertir estrategia,
              creatividad, medios y tecnología en acciones que tienen un porqué.
            </p>
            <p className="hero-text">
              Podemos ser tu equipo, complementar el que ya tenés o tomar un objetivo
              puntual y hacerlo avanzar.
            </p>
            <div className="hero-actions">
              <a className="button button-primary" href="#hablemos" onClick={() => handleCta("hero")}>
                CONTANOS QUÉ NECESITÁS <span aria-hidden="true">→</span>
              </a>
              <a className="text-link hero-secondary" href="#servicios">VER QUÉ HACEMOS <span>↓</span></a>
            </div>
          </div>

          <aside className="hero-system" aria-label="Cómo trabaja MOMO">
            <p className="system-kicker">UNA IDEA ES BUENA CUANDO HACE ALGO</p>
            {["ENTENDER", "ESTRATEGIA", "HACER", "MEDIR", "MEJORAR"].map((item, index) => (
              <div className={`system-line ${index === 4 ? "system-line-accent" : ""}`} key={item}>
                <span>{item}</span><strong>0{index + 1}</strong>
              </div>
            ))}
            <div className="system-result">
              <span>RESULTADO</span>
              <strong>MARKETING QUE TRABAJA</strong>
            </div>
          </aside>
        </section>

        <section className="proof-strip" aria-label="Qué aporta MOMO">
          <div className="proof-item"><strong>+15</strong><span>AÑOS HACIENDO</span></div>
          <div className="proof-item"><strong>1</strong><span>EQUIPO A MEDIDA</span></div>
          <div className="proof-item"><strong>360°</strong><span>ESTRATEGIA + EJECUCIÓN</span></div>
          <div className="proof-item"><strong>0</strong><span>ACCIONES PORQUE SÍ</span></div>
        </section>

        <section className="problem-section">
          <div className="problem-heading">
            <p className="eyebrow eyebrow-light">EL PROBLEMA NO ES HACER POCO</p>
            <h2>
              NO NECESITÁS HACER MÁS MARKETING.
              <br />
              <span>NECESITÁS QUE TODO TIRE PARA EL MISMO LADO.</span>
            </h2>
          </div>
          <div className="problem-copy">
            <p>
              Una pauta sin una buena landing. Redes sin objetivo. Una web que nadie mide.
              Un proveedor por cada cosa y nadie mirando el mapa completo.
            </p>
            <p className="problem-emphasis">
              MOMO conecta las piezas para que el marketing deje de ser una colección de tareas y se convierta en un sistema.
            </p>
          </div>
        </section>

        <section className="services-section" id="servicios">
          <div className="section-intro">
            <p className="eyebrow">LO QUE HACEMOS</p>
            <h2>
              TODO LO QUE EL NEGOCIO NECESITA.
              <br />
              <span>SOLO LO QUE TIENE SENTIDO.</span>
            </h2>
            <p>
              No vendemos un combo estándar. Armamos la combinación correcta según tu objetivo, tu estructura y el momento de tu negocio.
            </p>
          </div>

          <div className="services-list">
            {services.map((service) => (
              <article className="service" key={service.number}>
                <span className="service-number">{service.number}</span>
                <div className="service-main">
                  <h3>{service.title}</h3>
                  <p>{service.text}</p>
                </div>
                <div className="service-tags" aria-label={`Incluye ${service.title}`}>
                  {service.tags.map((tag) => <span key={tag}>{tag}</span>)}
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="external-section" id="marketing-externo">
          <div className="external-statement">
            <p className="eyebrow">DEPARTAMENTO DE MARKETING EXTERNO</p>
            <h2>
              TU EQUIPO DE MARKETING.
              <br />
              <span>SIN ARMAR UN EQUIPO ENTERO.</span>
            </h2>
          </div>
          <div className="external-copy">
            <p>
              Si tu empresa necesita más capacidad de marketing pero no tiene sentido incorporar una estructura completa, nos convertimos en ese equipo.
            </p>
            <p>
              Definimos el plan, coordinamos especialistas y proveedores, ejecutamos y medimos. Diseño, pauta, contenido, web, prensa, producción o lo que haga falta: <strong>una dirección, un criterio y un objetivo común.</strong>
            </p>
            <div className="external-points">
              <span>DIRECCIÓN SENIOR</span>
              <span>ESPECIALISTAS SEGÚN NECESIDAD</span>
              <span>UN SOLO PUNTO DE CONTACTO</span>
              <span>ESTRUCTURA FLEXIBLE</span>
            </div>
            <a className="text-link" href="#hablemos" onClick={() => handleCta("marketing_externo")}>
              QUIERO EVALUAR ESTE MODELO <span aria-hidden="true">↘</span>
            </a>
          </div>
        </section>

        <section className="method-section" id="metodo">
          <div className="method-title">
            <p className="eyebrow eyebrow-light">CÓMO TRABAJAMOS</p>
            <h2>NO ARRANCAMOS POR EL POSTEO.</h2>
            <p>Arrancamos por entender qué tiene que pasar en el negocio.</p>
          </div>
          <div className="process-list">
            {process.map((step) => (
              <article className="process-step" key={step.number}>
                <span>{step.number}</span>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </article>
            ))}
          </div>
          <div className="method-signature">
            <span>SABEMOS CÓMO HACER</span>
            <strong>LO QUE HAY QUE HACER.</strong>
          </div>
        </section>

        <section className="clients-section" id="clientes">
          <div className="clients-head">
            <div>
              <p className="eyebrow">EXPERIENCIA</p>
              <h2>MARCAS QUE CONFIARON EN NUESTRO TRABAJO.</h2>
            </div>
            <p>
              Más de quince años cruzando categorías, desafíos y tamaños de empresa. La experiencia sirve cuando ayuda a entender más rápido qué hacer ahora.
            </p>
          </div>
          <div className="clients-grid">
            {clients.map((client) => (
              <div className="client-card" key={client.file} title={client.name}>
                <img src={`/img/clientes/${client.file}.jpg`} alt={client.name} loading="lazy" />
              </div>
            ))}
          </div>
        </section>

        <section className="principles-section">
          <div className="principles-big">
            <span>ESTRATEGIA</span>
            <span>→</span>
            <span>ACCIÓN</span>
            <span>→</span>
            <span>RESULTADOS</span>
          </div>
          <div className="principles-copy">
            <p className="eyebrow">MOMO! AGENCIA</p>
            <h2>MENOS DEPARTAMENTOS. MÁS RESPONSABILIDAD.</h2>
            <p>
              Nos gusta pensar, pero también hacer. Por eso estrategia, creatividad, producción, medios, tecnología y análisis se hablan entre sí desde el principio.
            </p>
            <p>
              Trabajamos con equipos a medida, sin inflar estructura y sin obligarte a comprar servicios que no necesitás.
            </p>
          </div>
        </section>

        <section className="contact-section" id="hablemos">
          <div className="contact-copy">
            <p className="eyebrow eyebrow-light">EL PRÓXIMO PASO</p>
            <h2>¿HABLAMOS?</h2>
            <p className="contact-lead">
              Contanos qué querés mover y vemos si MOMO es el equipo indicado para hacerlo.
            </p>
            <div className="contact-proof">
              <span>5 DATOS.</span>
              <span>UNA CONVERSACIÓN.</span>
              <span>CERO HUMO.</span>
            </div>
          </div>

          <div className="form-card">
            <form ref={form} onSubmit={handleSubmit(createContact)} onFocus={handleFormFocus} noValidate>
              <input type="hidden" name="origen" value="web-momo-2026" />
              <input type="hidden" name="apellido" value={`Empresa: ${empresaValue}`} />
              <input type="hidden" name="landing_url" value={getAttribution().landing_url} />
              <input type="hidden" name="referrer" value={getAttribution().referrer} />
              <input type="hidden" name="utm_source" value={getAttribution().utm_source} />
              <input type="hidden" name="utm_medium" value={getAttribution().utm_medium} />
              <input type="hidden" name="utm_campaign" value={getAttribution().utm_campaign} />
              <input type="hidden" name="utm_content" value={getAttribution().utm_content} />

              <div className="form-row">
                <div className="field">
                  <label htmlFor="nombre">NOMBRE</label>
                  <input
                    id="nombre"
                    name="nombre"
                    type="text"
                    autoComplete="name"
                    placeholder="Tu nombre"
                    aria-invalid={errors.nombre ? "true" : "false"}
                    {...register("nombre", { required: "Decinos cómo te llamás." })}
                  />
                  {errors.nombre && <p className="field-error">{errors.nombre.message}</p>}
                </div>

                <div className="field">
                  <label htmlFor="empresa">EMPRESA</label>
                  <input
                    id="empresa"
                    type="text"
                    autoComplete="organization"
                    placeholder="Tu empresa"
                    aria-invalid={errors.empresa ? "true" : "false"}
                    {...register("empresa", { required: "Contanos de qué empresa venís." })}
                  />
                  {errors.empresa && <p className="field-error">{errors.empresa.message}</p>}
                </div>
              </div>

              <div className="form-row">
                <div className="field">
                  <label htmlFor="telefono">WHATSAPP</label>
                  <input
                    id="telefono"
                    name="telefono"
                    type="tel"
                    inputMode="tel"
                    autoComplete="tel"
                    placeholder="Ej. 11 5555 5555"
                    aria-invalid={errors.telefono ? "true" : "false"}
                    {...register("telefono", {
                      required: "Dejanos un WhatsApp para contactarte.",
                      validate: (value) => value.replace(/\D/g, "").length >= 8 || "Ingresá un número válido.",
                    })}
                  />
                  {errors.telefono && <p className="field-error">{errors.telefono.message}</p>}
                </div>

                <div className="field">
                  <label htmlFor="email">EMAIL</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    placeholder="vos@empresa.com"
                    aria-invalid={errors.email ? "true" : "false"}
                    {...register("email", {
                      required: "Dejanos un email de contacto.",
                      pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: "Ingresá un email válido." },
                    })}
                  />
                  {errors.email && <p className="field-error">{errors.email.message}</p>}
                </div>
              </div>

              <div className="field">
                <label htmlFor="objetivo">¿QUÉ QUERÉS RESOLVER?</label>
                <select
                  id="objetivo"
                  name="mensaje"
                  defaultValue=""
                  aria-invalid={errors.mensaje ? "true" : "false"}
                  {...register("mensaje", { required: "Elegí la opción que más se acerque a lo que necesitás." })}
                >
                  <option value="" disabled>Elegí una opción</option>
                  <option value="Estrategia o marketing integral">Estrategia o marketing integral</option>
                  <option value="Redes sociales y contenido">Redes sociales y contenido</option>
                  <option value="Pauta digital / performance">Pauta digital / performance</option>
                  <option value="Web o landing page">Web o landing page</option>
                  <option value="Departamento de marketing externo">Departamento de marketing externo</option>
                  <option value="Automatización / IA / digitalización">Automatización / IA / digitalización</option>
                  <option value="No estoy seguro, quiero conversar">No estoy seguro, quiero conversar</option>
                </select>
                {errors.mensaje && <p className="field-error">{errors.mensaje.message}</p>}
              </div>

              <button className="button button-form" type="submit" disabled={isSending}>
                {isSending ? "ENVIANDO..." : "QUIERO HABLAR CON MOMO"}
                {!isSending && <span aria-hidden="true">→</span>}
              </button>

              <p className="privacy-note">
                Al enviar tus datos aceptás que MOMO te contacte por estos medios para conversar sobre tu consulta.
              </p>
            </form>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="footer-brand">
          <img src="/img/logoN.png" alt="MOMO! Agencia" />
          <p>ESTRATEGIA <span>→</span> ACCIÓN <span>→</span> RESULTADOS</p>
        </div>
        <div className="footer-links">
          <a href="mailto:hola@momoagencia.com">hola@momoagencia.com</a>
          <a href="https://www.instagram.com/momoagencia/" target="_blank" rel="noreferrer">@momoagencia</a>
        </div>
        <span className="footer-note">MOMO! Agencia · Argentina</span>
      </footer>
    </div>
  );
};

export default Home;
